import createReactComponent from '../createReactComponent';
export default createReactComponent('ripple', 'IconRipple', [
  ['path', { d: 'M3 7c3 -2 6 -2 9 0s6 2 9 0', key: 'svg-0' }],
  ['path', { d: 'M3 17c3 -2 6 -2 9 0s6 2 9 0', key: 'svg-1' }],
  ['path', { d: 'M3 12c3 -2 6 -2 9 0s6 2 9 0', key: 'svg-2' }],
]);
